import { createActionType } from '../../helpers'

export const UPDATE_TITLE = createActionType('BREADCRUMBS', 'UPDATE_TITLE')
